import { Dictionary, pickBy } from 'lodash';

const OVERLAY_REGEX = /^([a-zA-z\d]+)-(\d+)$/gm;

/**
 * Filters out overlays from dictionaries using the key.
 * @param unfiltered
 * @returns a dictionary with all of the overlayed objects removed
 */
export function filterOverlays<T>(unfiltered: Dictionary<T>) {
  return pickBy(unfiltered, (_: T, key: string) => !isOverlayedStorageKey(key));
}

/**
 * Checks to see if the storage key/id is an overlayed object
 * @param key storage key / storage id
 * @returns true if key is an overlayed object
 */
export const isOverlayedStorageKey = (key: string) => !!key.match(OVERLAY_REGEX);
